export const entityNotesComponent = {
  templateUrl: "admin/views/entity-general-notes-modal.html",
  controller: "entityGeneralNotesModalCtrl"
  // Controller data is stored in entityNotesModalService.notesData
};
